import React, { useState } from 'react';
import EyeIcon from '../icons/EyeIcon';
import EyeOffIcon from '../icons/EyeOffIcon';

const Input = ({type,name,value,placeholder,required,onChange}) => {
  const isPassword = type === 'password';
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className='my-5 relative'>
        <input 
            className={`h-[45px] px-4 ${isPassword ? 'pr-11' : ''} bg-custom-charcoal border border-custom-light-grey rounded-md w-full`} 
            type={isPassword ? (showPassword ? 'text' : 'password') : (type ? type : 'text')} 
            name={name || ''} 
            value={value || ''} 
            placeholder={placeholder || ''} 
            required={required ? true : false}
            onChange={onChange || null}
        />
        {isPassword && (
            <button
                type='button'
                onClick={() => setShowPassword((prev) => !prev)}
                className='absolute right-3 top-1/2 -translate-y-1/2 text-custom-light-grey'
                aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
            </button>
        )}
    </div>
  );
};

export default Input;

